import { render, staticRenderFns } from "./BestPractices.vue?vue&type=template&id=b5132288"
import script from "./BestPractices.vue?vue&type=script&lang=js"
export * from "./BestPractices.vue?vue&type=script&lang=js"
import style0 from "./BestPractices.vue?vue&type=style&index=0&id=b5132288&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports